"use strict";

var robustSum = require("robust-sum");

var robustScale = require("robust-scale");

module.exports = robustProduct;

function robustProduct(a, b) {
  if (a.length === 1) {
    return robustScale(b, a[0]);
  }

  if (b.length === 1) {
    return robustScale(a, b[0]);
  }

  if (a.length === 0 || b.length === 0) {
    return [0];
  }

  var r = [0];

  if (a.length < b.length) {
    for (var i = 0; i < a.length; ++i) {
      r = robustSum(r, robustScale(b, a[i]));
    }
  } else {
    for (var i = 0; i < b.length; ++i) {
      r = robustSum(r, robustScale(a, b[i]));
    }
  }

  return r;
}